import { useState, useEffect } from "react";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";

export default function GameRoom({ gameId, team, setGameStarted }) {
  const [number, setNumber] = useState("");
  const [gameData, setGameData] = useState(null);
  const [numberSet, setNumberSet] = useState(false); // 🔹 숫자가 이미 설정되었는지 확인

  useEffect(() => {
    const fetchGameData = async () => {
      const gameRef = doc(db, "games", gameId);
      const gameSnap = await getDoc(gameRef);
      if (gameSnap.exists()) {
        const data = gameSnap.data();
        setGameData(data);

        // 🔹 숫자가 이미 설정되어 있으면 바로 게임 시작
        if ((team === "red" && data.redAnswer) || (team === "blue" && data.blueAnswer)) {
          setNumberSet(true);
          setGameStarted(true);
        }
      }
    };

    fetchGameData();
  }, [gameId, team, setGameStarted]);

  const handleStartGame = async () => {
    if (number.length !== 4 || isNaN(number)) {
      alert("4자리 숫자를 입력하세요.");
      return;
    }

    const gameRef = doc(db, "games", gameId);
    const updateData = team === "red" ? { redAnswer: number } : { blueAnswer: number };
    await updateDoc(gameRef, updateData);

    setNumberSet(true);
    setGameStarted(true); // 🔹 숫자 설정과 동시에 게임 시작
  };

  if (numberSet) {
    return <p className="text-center text-green-500">숫자가 설정되었습니다. 게임이 시작됩니다!</p>;
  }

  return (
    <div className="container">
      <h2>4자리 숫자를 입력하세요</h2>
      <input
        type="text"
        value={number}
        onChange={(e) => setNumber(e.target.value)}
        maxLength="4"
        placeholder="예: 1234"
      />
      <button onClick={handleStartGame} className="green-btn">
        숫자 설정 및 게임 시작
      </button>
    </div>
  );
}
